import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import logo from "../../../assests/img/logo.png";
import DehazeIcon from "@mui/icons-material/Dehaze";

const Header = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? "active-link" : "span_color";
  };

  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  window.addEventListener("scroll", toggleVisible);

  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <>
      <header className="site-header mo-left header style-2">
        <div className="sticky-header main-bar-wraper navbar-expand-lg">
          <div className="main-bar clearfix ">
            <div className="container-fluid clearfix">
              {/* <div className="logo-header mostion logo-dark">
                <a href="#">
                  <img src={logo} alt="logo" />
                </a>
              </div> */}

              <div
                className="header-nav navbar-collapse toggle_flex"
                id="navbarNavDropdown"
              >
                <div className="logo-header logo-dark">
                  <a href="/">
                    <img src={logo} alt="logo" width="200px" />
                  </a>
                   <div className="toggle_btn" onClick={toggleMenu}>
                    <DehazeIcon />
                  </div>
                </div>
                <div className={`toggle_flex_sec ${menuOpen ? "show" : "hide"}`}>
                  <div className="d-flex gap-2 align-items-center">
                    <ul
                      className="nav navbar-nav navbar / navbar-left dropdowni"
                      id="dropdowni"
                    >
                      <li>
                        <a>About Us</a>
                        <ul>
                          <li>
                            <a href="/about-us" target="_self">
                              About Us
                            </a>
                          </li>
                          <li>
                            <a href="our-inspiration" target="_self">
                              Our Inspiration
                            </a>
                          </li>
                          <li>
                            <a href="history" target="_self">
                              History
                            </a>
                          </li>
                          <li>
                            <a>Messages</a>
                            <ul>
                              <li>
                                <a href="founder-message" target="_self">
                                  Founder’s Message
                                </a>
                              </li>
                              <li>
                                <a href="director-message" target="_self">
                                  Director’s Message
                                </a>
                              </li>
                              <li>
                                <a href="patron-message" target="_self">
                                  Patron Message
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <a href="our-aims" target="_self">
                              Our Aims
                            </a>
                          </li>
                          <li>
                            <a href="our-ethos" target="_self">
                              Our Ethos
                            </a>
                          </li>
                          <li>
                            <a href="our-vision" target="_self">
                              Our Vision
                            </a>
                          </li>
                        </ul>{" "}
                      </li>
                      <li>
                        <a>Admission</a>
                        <ul>
                          <li>
                            <a href="online-registration" target="_self">
                              Online Registration
                            </a>
                          </li>
                          <li>
                            <a href="admission-procedure" target="_self">
                              Admission Procedure
                            </a>
                          </li>
                          <li>
                            <a href="fees-structure" target="_self">
                              Fees Structure
                            </a>
                          </li>
                          <li>
                            <a href="download-brochure" target="_self">
                              Download Brochure
                            </a>
                          </li>
                        </ul>{" "}
                      </li>
                      <li>
                        <a>Student Life</a>
                        <ul>
                          <li>
                            <a
                              href="spiritual-care-and-wellbeing"
                              target="_self"
                            >
                              Spiritual care and Wellbeing
                            </a>
                          </li>
                          <li>
                            <a href="academic-life" target="_self">
                              Academic life
                            </a>
                          </li>
                          <li>
                            <a href="sporting-life" target="_self">
                              Sporting Life
                            </a>
                          </li>
                          <li>
                            <a href="co-curricular" target="_self">
                              Co-curricular
                            </a>
                          </li>
                          <li>
                            <a href="social-responsibility" target="_self">
                              Social Responsibility
                            </a>
                          </li>
                          <li>
                            <a href="activities" target="_self">
                              Activities
                            </a>
                          </li>
                          <li>
                            <a href="amenities" target="_self">
                              Amenities
                            </a>
                          </li>
                        </ul>{" "}
                      </li>
                      <li>
                        <a>Facilities</a>
                        <ul>
                          <li>
                            <a href="smart-classrooms" target="_self">
                              Smart classrooms
                            </a>
                          </li>
                          <li>
                            <a href="library" target="_self">
                              Library
                            </a>
                          </li>
                          <li>
                            <a href="computer-lab" target="_self">
                              Computer Lab
                            </a>
                          </li>
                          <li>
                            <a href="science-lab" target="_self">
                              Science Lab
                            </a>
                          </li>
                          <li>
                            <a href="sports" target="_self">
                              Sports
                            </a>
                          </li>
                          <li>
                            <a href="transport" target="_self">
                              Transport
                            </a>
                          </li>
                          <li>
                            <a href="skill-lab" target="_self">
                              Skill Lab
                            </a>
                          </li>
                          <li>
                            <a href="school-clubs" target="_self">
                              School Clubs
                            </a>
                          </li>
                        </ul>{" "}
                      </li>
                      <li>
                        <a href="downloads">Downloads</a>
                      </li>
                      <li>
                        <a href="gallery">Gallery</a>
                      </li>
                      <li>
                        <a href="contact-us" style={{ border: "none" }}>
                          Contact
                        </a>
                      </li>
                      <li>
                        <a href="blog" style={{ border: "none" }}>
                          Blog
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <a
                      className="btn btn-primary btnhover1"
                      href="online-registration"
                    >
                      <span>Online Registration</span>
                      {/* <i className="flaticon-right-arrows text-secondary ms-3"></i> */}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
